/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
/**
 * DplusService - axios parameter creator
 * @export
 */
export const DplusServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Aktualisiert die Objekte im Index (und Cache) eines bestimmten Types mit bestimmten Ids
         * @summary Update Index + Cache Objekte
         * @param {'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND'} type 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update2: async (type: 'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND', ids: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('update2', 'type', type)
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('update2', 'ids', ids)
            const localVarPath = `/api/dplus-update/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualisiert den Index und gecachte Daten eines bestimmten Types
         * @summary Update Index + Cache
         * @param {'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateData: async (type: 'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('updateData', 'type', type)
            const localVarPath = `/api/dplus-update/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DplusService - functional programming interface
 * @export
 */
export const DplusServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DplusServiceAxiosParamCreator(configuration)
    return {
        /**
         * Aktualisiert die Objekte im Index (und Cache) eines bestimmten Types mit bestimmten Ids
         * @summary Update Index + Cache Objekte
         * @param {'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND'} type 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update2(type: 'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND', ids: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update2(type, ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Aktualisiert den Index und gecachte Daten eines bestimmten Types
         * @summary Update Index + Cache
         * @param {'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateData(type: 'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateData(type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DplusService - factory interface
 * @export
 */
export const DplusServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DplusServiceFp(configuration)
    return {
        /**
         * Aktualisiert die Objekte im Index (und Cache) eines bestimmten Types mit bestimmten Ids
         * @summary Update Index + Cache Objekte
         * @param {'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND'} type 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update2(type: 'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND', ids: Array<number>, options?: any): AxiosPromise<void> {
            return localVarFp.update2(type, ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualisiert den Index und gecachte Daten eines bestimmten Types
         * @summary Update Index + Cache
         * @param {'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateData(type: 'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND', options?: any): AxiosPromise<void> {
            return localVarFp.updateData(type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DplusService - interface
 * @export
 * @interface DplusService
 */
export interface DplusServiceInterface {
    /**
     * Aktualisiert die Objekte im Index (und Cache) eines bestimmten Types mit bestimmten Ids
     * @summary Update Index + Cache Objekte
     * @param {'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND'} type 
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DplusServiceInterface
     */
    update2(type: 'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND', ids: Array<number>, options?: any): AxiosPromise<void>;

    /**
     * Aktualisiert den Index und gecachte Daten eines bestimmten Types
     * @summary Update Index + Cache
     * @param {'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND'} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DplusServiceInterface
     */
    updateData(type: 'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND', options?: any): AxiosPromise<void>;

}

/**
 * DplusService - object-oriented interface
 * @export
 * @class DplusService
 * @extends {BaseAPI}
 */
export class DplusService extends BaseAPI implements DplusServiceInterface {
    /**
     * Aktualisiert die Objekte im Index (und Cache) eines bestimmten Types mit bestimmten Ids
     * @summary Update Index + Cache Objekte
     * @param {'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND'} type 
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DplusService
     */
    public update2(type: 'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND', ids: Array<number>, options?: any) {
        return DplusServiceFp(this.configuration).update2(type, ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualisiert den Index und gecachte Daten eines bestimmten Types
     * @summary Update Index + Cache
     * @param {'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND'} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DplusService
     */
    public updateData(type: 'ADRESSE' | 'AUFTRAG' | 'BENUTZER' | 'GEFAHRGUTKLASSE' | 'MANDANT' | 'ORT' | 'VERPACKUNG' | 'ADRESSE_ORIGINS' | 'LAND', options?: any) {
        return DplusServiceFp(this.configuration).updateData(type, options).then((request) => request(this.axios, this.basePath));
    }
}
